import { Component, DestroyRef, inject, OnInit } from "@angular/core";
import { takeUntilDestroyed } from "@angular/core/rxjs-interop";
import { NxSpinnerModule } from "@aposin/ng-aquila/spinner";
import { LoadingService } from "src/app/shared/services/loading/loading.service";

@Component({
  selector: "app-loading",
  standalone: true,
  imports: [NxSpinnerModule],
  templateUrl: "./loading.component.html",
  styleUrl: "./loading.component.scss",
})
export class LoadingComponent implements OnInit {
  private readonly destroyRef = inject(DestroyRef);

  protected loading: boolean = false;

  constructor(private readonly loadingScreenService: LoadingService) {}

  ngOnInit(): void {
    this.loading = this.loadingScreenService.loading;
    this.loadingScreenService.loadingStatus$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((status: boolean) => {
        this.loading = status;
      });
  }
}
